<template>
    <transition name="cz3__fade">
        <div
            v-if="showModal"
            class="z-50 fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black bg-opacity-30"
        >
            <div class="shadow-md rounded max-h-full overflow-auto w-full sm:w-11/12 max-w-5xl p-4 md:p-9 bg-white text-ink">
                <div class="mb-6 flex items-center justify-between">
                    <h1 class="text-2xl font-bold tracking-wide">
                        {{ feedback.message }}
                    </h1>

                    <button
                        @click="emitClose"
                        type="button"
                        aria-label="close modal"
                    >
                        <img
                            src="../assets/images/icons/close.svg"
                            width="20"
                            height="20"
                            alt="X"
                        >
                    </button>
                </div>

                <div class="flex justify-end">
                    <base-button-flat
                        @click="openLoginPage"
                        class="w-28 h-10"
                    >
                        OK
                    </base-button-flat>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import BaseButtonFlat from './BaseButtonFlat.vue';

    export default {
        components: {
            BaseButtonFlat,
        },

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },

            feedback: {
                type: Object,
                required: true,
            },
        },

        methods: {
            openLoginPage() {
                window.open(this.feedback.url, '_self');
            },

            emitClose() {
                this.$emit('modalClose');
            },
        },
    };
</script>
